import { QualificationModalInitialState } from './reducers';

export const getQualificationsState = ({ pages: { qualifications } }) =>
  qualifications as QualificationModalInitialState;

